import * as BABYLON from "babylonjs";
import AssetLoader from "../3d/loaders/AssetLoader";
import Main from "scripts/3d/experience/Main";
import { degToRad } from "./degToRad";

class VFX {
  constructor(scene) {
    this.particlesSledSnow();
    this.particlesPresents();
    this.isBackingUp = false;
    this.introComplete = false;
    this.useRainbow = false;
    // this.particlesTimeBonus();
    // this.particlesSpeed();
  }

  particlesSledSnow() {
    this.snowemitter = new BABYLON.TransformNode();
    const smokeParticleCount = 1000;
    const dustParticleCount = 500;
    const rainbowParticleCount = 500;
    const brightParticleCount = 50;

    const smokeParticles = new BABYLON.ParticleSystem(
      "particlesSledSnow",
      smokeParticleCount
    );
    this.dustParticles = new BABYLON.GPUParticleSystem(
      "particlesSledDust",
      dustParticleCount
    );
    this.createDustParticles(this.dustParticles, false);

    this.rainbowParticles = new BABYLON.GPUParticleSystem(
      "rainbowParticles",
      rainbowParticleCount
    );
    this.rainbowParticles.stop();
    this.createDustParticles(this.rainbowParticles, true)

    const brightParticles = new BABYLON.GPUParticleSystem(
      "particlesSledBrights",
      brightParticleCount,
    );

    // const smokeEmitterPlane = BABYLON.MeshBuilder.CreateBox("smokeEmitterBox", {
    //   width: 0.3,
    //   height: 0, //0.00001,
    //   depth: 0, //0.000001,
    // });

    // smokeEmitterPlane.visibility = false;
    // smokeEmitterPlane.rotation.x = degToRad(90); //Math.PI / 2
    // smokeEmitterPlane.position.y = 0.1;
    // smokeEmitterPlane.position.z = 1; //0.7;
    // smokeEmitterPlane.isPickable = false;

    // const smokeEmitter = new BABYLON.BoxParticleEmitter(smokeEmitterPlane);
    // const smokeEmitter = new BABYLON.PointParticleEmitter(new BABYLON.Vector3(-1, 0, 0), new BABYLON.Vector3(1, 0, 0));
    smokeParticles.createPointEmitter(
      new BABYLON.Vector3(-0.5, 0, -1),
      new BABYLON.Vector3(0.5, 0, -1)
    );
    this.smokeParticlesEmitter = new BABYLON.TransformNode();
    smokeParticles.emitter = this.smokeParticlesEmitter;
    //smokeParticles.emitter = smokeEmitterPlane;
    // smokeParticles.particleEmitterType = smokeEmitter;
    // smokeParticles.worldOffset = new BABYLON.Vector3(0, -0.3, 0.1);
    smokeParticles.addSizeGradient(0, 0.01);
    smokeParticles.addSizeGradient(0.5, 1);
    smokeParticles.addSizeGradient(1, 4.01);
    smokeParticles.particleTexture = AssetLoader.getTexture("SledCloud");
    // smokeParticles.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD;
    smokeParticles.blendMode = BABYLON.ParticleSystem.BLENDMODE_STANDARD;
    // smokeParticles.particleEmitterType.directionRandomizer = 1;
    smokeParticles.minLifeTime = 0.5;
    smokeParticles.maxLifeTime = 1;
    smokeParticles.emitRate = 100;
    // smokeParticles.color1 = new BABYLON.Color4(0.612, 0.976, 0.969, 1);
    // smokeParticles.color2 = new BABYLON.Color4(0.341, 0.796, 0.965, 0.8);
    // smokeParticles.colorDead = new BABYLON.Color4(0.816, 0.98, 0.965, 0);
    smokeParticles.color1 = new BABYLON.Color4(1, 1, 1, 1);
    // smokeParticles.color2 = new BABYLON.Color4(1,1,1, 0.8);
    smokeParticles.colorDead = new BABYLON.Color4(1, 1, 1, 0);
    smokeParticles.gravity = new BABYLON.Vector3(0, 0, 20);
    smokeParticles.direction1 = new BABYLON.Vector3(0, 0, 1);
    // smokeParticles.direction1 = new BABYLON.Vector3(1, 0, 1);
    // smokeParticles.direction2 = new BABYLON.Vector3(-1, 0, 1);
    smokeParticles.isLocal = false;
    smokeParticles.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;
    this.smokeParticles = smokeParticles;
    this.smokeParticlesEmitter.setParent(this.snowemitter);

    const brightEmitterPlane = BABYLON.MeshBuilder.CreateBox(
      "brightEmiterBox",
      {
        width: 0.3,
        height: 0.0001,
        depth: 0.01,
      }
    );
    brightEmitterPlane.visibility = false;
    brightEmitterPlane.rotation.x = degToRad(0);
    brightEmitterPlane.position.y = 0.1;
    brightEmitterPlane.position.z = 0.9;
    brightEmitterPlane.isPickable = false;

    const brightEmitter = new BABYLON.BoxParticleEmitter(brightEmitterPlane);
    // dustParticles.emitter = cone
    brightParticles.emitter = brightEmitterPlane;
    brightParticles.particleEmitterType = brightEmitter;
    brightParticles.worldOffset = new BABYLON.Vector3(0, 0.0, 0.1);
    brightParticles.particleTexture = AssetLoader.getTexture("SledFake");
    brightParticles.startSpriteCellID = 0;
    brightParticles.endSpriteCellID = 2;
    brightParticles.spriteCellHeight = 64;
    brightParticles.spriteCellWidth = 64;
    brightParticles.spriteRandomStartCell = true;
    brightParticles.isAnimationSheetEnabled = true;
    brightParticles.addSizeGradient(0, 0.001, 0.002);
    brightParticles.addSizeGradient(1, 0.2, 0.1);

    brightParticles.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD; //ADD
    brightParticles.particleEmitterType.directionRandomizer = 1;
    brightParticles.direction1 = new BABYLON.Vector3(5, 0, -1);
    brightParticles.direction2 = new BABYLON.Vector3(-5, 0, 1);
    brightParticles.minLifeTime = 0.1;
    brightParticles.maxLifeTime = 0.8;
    brightParticles.minEmitBox = new BABYLON.Vector3(-0.25, 0, -0.5);
    brightParticles.maxEmitBox = new BABYLON.Vector3(0.25, 0, 0.1);
    brightParticles.emitRate = 2;
    brightParticles.color1 = new BABYLON.Color4(0.012, 0.337, 0.725, 0);
    brightParticles.color2 = new BABYLON.Color4(0.341, 0.796, 0.965, 0.8);
    brightParticles.colorDead = new BABYLON.Color4(0.816, 0.98, 0.965, 0);
    // brightParticles.color1 = new BABYLON.Color4(1, 1, 1, 0);
    // brightParticles.color2 = new BABYLON.Color4(1, 1, 1, 1);
    // brightParticles.colorDead = new BABYLON.Color4(1, 1, 1, 0);
    brightParticles.gravity = new BABYLON.Vector3(0, 3, 30);
    // brightParticles.minAngularSpeed = 0;
    // brightParticles.maxAngularSpeed = Math.PI;
    brightParticles.minEmitPower = 0.5;
    brightParticles.maxEmitPower = 0.75;
    brightParticles.updateSpeed = 0.005;
    brightParticles.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;
    this.brightParticles = brightParticles;
    brightEmitterPlane.setParent(this.snowemitter);

    this.sledSnow = [this.dustParticles, smokeParticles, brightParticles];
    this.stopSledSnow();

  }

  createDustParticles(particles, isRainbow) {
    const dustEmitterPlane = BABYLON.MeshBuilder.CreateBox(`${isRainbow ? "rainbowEmitterBox" : "dustEmitterBox"}`, {
      width: 0.3,
      height: 0.0001,
      depth: 0.01,
    });
    dustEmitterPlane.visibility = false;
    dustEmitterPlane.rotation.x = degToRad(0);
    dustEmitterPlane.position.y = 0;
    dustEmitterPlane.position.z = 0.7;
    dustEmitterPlane.isPickable = false;

    const dustEmitter = new BABYLON.BoxParticleEmitter(dustEmitterPlane);
    // dustParticles.emitter = cone
    particles.emitter = dustEmitterPlane;
    particles.particleEmitterType = dustEmitter;
    particles.worldOffset = new BABYLON.Vector3(0, 0.0, 0.1);
    // dustParticles.createConeEmitter(radius, height)
    particles.addSizeGradient(0, 0.03, 0.05);
    // dustParticles.addSizeGradient(0.1, 0.008, 0.01);
    particles.addSizeGradient(1, 1, 0.75);
    particles.particleTexture = AssetLoader.getTexture("SledSpatter");
    if(isRainbow) {
      particles.blendMode = BABYLON.ParticleSystem.BLENDMODE_STANDARD;
    } else {
      particles.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD;
    }
    particles.particleEmitterType.directionRandomizer = 1;
    particles.direction1 = new BABYLON.Vector3(5, 0, -1);
    particles.direction2 = new BABYLON.Vector3(-5, 0, 1);
    particles.minLifeTime = 0.1;
    particles.maxLifeTime = 0.8;
    particles.minEmitBox = new BABYLON.Vector3(-0.25, 0, -0.5);
    particles.maxEmitBox = new BABYLON.Vector3(0.25, 0, 0.1);
    particles.emitRate = isRainbow ? 35 : 20; //dustParticleCount / 10;
    // dustParticles.color1 = new BABYLON.Color4(0.012, 0.337, 0.725, 1);
    // dustParticles.color2 = new BABYLON.Color4(0.341, 0.796, 0.965, 0.8);
    // dustParticles.colorDead = new BABYLON.Color4(0.816, 0.98, 0.965, 1);

    if(isRainbow) {
      particles.addColorGradient(.12, new BABYLON.Color4(.61, .3, .59, 1), new BABYLON.Color4(.61, .3, .59, 1)); //
      particles.addColorGradient(.38, new BABYLON.Color4(1, .39, .33, 1), new BABYLON.Color4(1, .39, .33, 1)); //
      particles.addColorGradient(.56, new BABYLON.Color4(.98, .66, .25, 1), new BABYLON.Color4(.98, .66, .25, 1)); //
      particles.addColorGradient(.75, new BABYLON.Color4(.98, .89, .26, 1), new BABYLON.Color4(.98, .89, .26, 1)); //
      particles.addColorGradient(.9, new BABYLON.Color4(.55, .83, .28, 1), new BABYLON.Color4(.55, .83, .28, 1)); //color range at start of particle lifetime
      particles.addColorGradient(1, new BABYLON.Color4(.16, .65, .95, 1), new BABYLON.Color4(.16, .65, .95, 1));
    } else {
      particles.color1 = new BABYLON.Color4(1, 1, 1, 0);
      particles.color2 = new BABYLON.Color4(1, 1, 1, 1);
    }
    
    // dustParticles.colorDead = new BABYLON.Color4(1, 1, 1, 0);
    particles.gravity = new BABYLON.Vector3(0, 3, 30);
    // dustParticles.minAngularSpeed = 0;
    // dustParticles.maxAngularSpeed = Math.PI;
    particles.minEmitPower = 0.5;
    particles.maxEmitPower = 0.75;
    particles.updateSpeed = 0.005;
    particles.billboardMode = BABYLON.AbstractMesh.BILLBOARDMODE_ALL;
    dustEmitterPlane.setParent(this.snowemitter);
  }

  particlesPresents() {
    this.currentPresent = 0;
    let p;
    this.present = [];
    this.presentEmitter = [];
    //PRESENT BURST
    for (var i = 0; i < 5; i++) {
      p = new BABYLON.ParticleSystem("particlesPresents" + i, 100);
      //Texture of each particle
      //p.particleTexture = AssetLoader.getTexture("Star");

      p.isAnimationSheetEnabled = true;
      p.particleTexture = AssetLoader.getTexture("PresentSparks"); //Star
      p.startSpriteCellID = 0;
      p.endSpriteCellID = 2;
      p.spriteCellHeight = 128;
      p.spriteCellWidth = 128;
      p.spriteRandomStartCell = true;
      // particleSystem.spriteCellChangeSpeed = .1;
      p.isAnimationSheetEnabled = true;
      // p.particleTexture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
      // p.particleTexture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE;
      // p.spriteCellWidth = 512 / 2;
      // p.spriteCellHeight = 512 / 2;
      // let numberCells = 4;
      // p.startSpriteCellID = 0;
      // p.endSpriteCellID = numberCells - 1;
      // p.spriteCellChangeSpeed = 0;
      // p.spriteRandomStartCell = true;
      // p.updateSpeed = 1 / 60;

      // Position where the particles are emitted from
      var emitter = new BABYLON.TransformNode();
      emitter.position = new BABYLON.Vector3(0, 0, 0);
      p.emitter = emitter;
      // particleSystem.start();
      p.manualEmitCount = 100;
      p.minAngularSpeed = 5; // 65;
      p.maxAngularSpeed = 30;
      // p.minSize = 0.05;
      // p.maxSize = 0.2;
      p.minSize = 0.1;
      p.maxSize = 0.3;
      p.emitRate = 30;
      p.minLifeTime = 1;
      p.maxLifeTime = 1;
      // p.gravity = new BABYLON.Vector3(0, -1, 6);
      p.gravity = new BABYLON.Vector3(0, 0, 0);
      // p.direction1 = new BABYLON.Vector3(0, 0, 1);
      p.direction1 = new BABYLON.Vector3(-0.4, 1, -0.4);
      p.direction2 = new BABYLON.Vector3(0.4, 1, 0.4);
      p.isLocal = true;
      p.minEmitPower = 5;
      p.maxEmitPower = 7;
      this.present[i] = p;
      //p.blendMode = BABYLON.ParticleSystem.BLENDMODE_STANDARD;
      // p.blendMode = BABYLON.ParticleSystem.BLENDMODE_MULTIPLYADD;
      p.blendMode = BABYLON.ParticleSystem.BLENDMODE_ADD; //STANDARD;
    }
  }

  particlesSpeed() {
    let p = new BABYLON.ParticleSystem("particlesSpeed", 50);
    p.particleTexture = AssetLoader.getTexture("Snow");
    p.updateSpeed = 1 / 60;

    var emitter = new BABYLON.TransformNode();
    p.billboardMode = BABYLON.ParticleSystem.BILLBOARDMODE_Y;
    emitter.position = new BABYLON.Vector3(0, 0, 1);
    p.emitter = emitter;

    let coneEmitter = p.createPointEmitter(
      new BABYLON.Vector3(0, 3, 0),
      new BABYLON.Vector3(0, 3, 0)
    );
    coneEmitter.radiusRange = 0;
    coneEmitter.heightRange = 0;
    p.particleEmitterType = coneEmitter;

    this.speedemitter = emitter;

    p.gravity = new BABYLON.Vector3(0, 0, 10);

    p.minInitialRotation = Math.PI;
    p.maxInitialRotation = Math.PI;
    p.minScaleX = 1;
    p.maxScaleX = 1;
    p.minScaleY = 1;
    p.maxScaleY = 1;
    p.minLifeTime = 2;
    p.maxLifeTime = 2;
    p.emitRate = 5;
    p.minEmitPower = 0.5;
    p.maxEmitPower = 0.5;
    p.minSize = 1;
    p.maxSize = 1;

    p.isLocal = false;

    // p.addColorGradient(0, new BABYLON.Color4(0, 0, 0, 0));
    // p.addColorGradient(
    //   0.5,
    //   new BABYLON.Color4(0.99, 0.92, 0.52, 0.5)
    // );
    // p.addColorGradient(1.0, new BABYLON.Color4(0, 0, 0, 0));

    p.blendMode = BABYLON.ParticleSystem.BLENDMODE_ONEONE; //BLENDMODE_ADD;

    //p.start();
    this.speed = p;
  }

  startSledSnow() {
    this.snowemitter.setParent(Main.sled.view);
    // this.speedemitter.setParent(Main.sled.view);
    
    // for (var i = 0; i < 5; i++)
    //   this.present[i].emitter.setParent(Main.sled.view);

    this.beginSledSnow();
  }

  beginSledSnow() {
    this.brightParticles.start();
    if(this.useRainbow) {
      this.rainbowParticles.start();
    } else {
      this.dustParticles.start();
    }
    this.smokeParticles.start();
  }

  stopSledSnow() {
    this.brightParticles.stop();
    this.rainbowParticles.stop();
    this.rainbowParticles.reset();
    this.dustParticles.stop();
    this.smokeParticles.stop()
  }

  boostOn() {
    if(this.introComplete === false) return
    //NEED TO STOP SYSTEM, MOD SETTINGS, THEN START AGAIN TO MAKE SETTINGS STICK!!!
    // console.log("BOOST START!!!!");
    this.dustParticles.stop();
    this.rainbowParticles.stop();
    this.dustParticles.emitRate = 200;
    this.rainbowParticles.emitRate = 130;
    this.dustParticles.gravity = this.rainbowParticles.gravity = new BABYLON.Vector3(0, 3, 60);
    // this.dustParticles.color2 =  new BABYLON.Color4(1, 0,0, 1);
    // this.dustParticles.colorDead =  new BABYLON.Color4(1, 0,0, 0);
    // this.dustParticles.removeSizeGradient(0);
    // this.dustParticles.removeSizeGradient(1);
    // this.dustParticles.addSizeGradient(0, 0.03, 0.05);
    // this.dustParticles.addSizeGradient(1, 6, 4.75);
    // this.dustParticles.reset();
    if(this.useRainbow) {
      this.rainbowParticles.start();
    } else {
      this.dustParticles.start();
    }

    this.smokeParticles.stop();
    this.smokeParticles.emitRate = 200;
    this.smokeParticles.gravity = new BABYLON.Vector3(0, 0, 50);
    this.smokeParticles.start();

    this.brightParticles.stop();
    this.brightParticles.emitRate = 5;
    this.brightParticles.gravity = new BABYLON.Vector3(0, 3, 60);
    this.brightParticles.start();
  }

  boostOff() {
    if(this.introComplete === false) return
    // console.log("BOOST END!!!!");
    this.dustParticles.stop();
    this.rainbowParticles.stop();

    this.dustParticles.emitRate = 20;
    this.rainbowParticles.emitRate = 35;
    this.dustParticles.gravity = this.rainbowParticles.gravity = new BABYLON.Vector3(0, 3, 30);
    // this.dustParticles.color2 =  new BABYLON.Color4(1, 1, 1, 1);
    // this.dustParticles.colorDead =  new BABYLON.Color4(1, 1, 1, 0);
    // this.dustParticles.removeSizeGradient(0);
    // this.dustParticles.removeSizeGradient(1);
    // this.dustParticles.addSizeGradient(0, 0.03, 0.05);
    // this.dustParticles.addSizeGradient(1, 1, 0.75);
    if(this.useRainbow) {
      this.rainbowParticles.start();
    } else {
      this.dustParticles.start();
    }

    this.smokeParticles.stop();
    this.smokeParticles.emitRate = 100;
    this.smokeParticles.gravity = new BABYLON.Vector3(0, 0, 20);
    this.smokeParticles.start();

    this.brightParticles.stop();
    this.brightParticles.emitRate = 2;
    this.brightParticles.gravity = new BABYLON.Vector3(0, 3, 30);
    this.brightParticles.start();
  }

  backingUp() {
    // console.log("BACKUP");
    // this.dustParticles.stop();
    // this.smokeParticles.stop();
    // this.brightParticles.stop();
    this.stopSledSnow();
    this.isBackingUp = true;
  }

  notBackingUp() {
    if (this.isBackingUp) {
      // console.log("STOPBACKUP");
      // this.dustParticles.start();
      // this.smokeParticles.start();
      // this.brightParticles.start();
      this.startSledSnow();
      this.isBackingUp = false;
    }
  }

  extraTime() {
    this.timeBonus.stop();
    this.timeBonus.reset();
    this.timeBonus.manualEmitCount = 3;
    this.timeBonus.emitter = new BABYLON.Vector3(
      Main.sled.xpos(),
      Main.sled.ypos() + 1,
      1
    );
    this.timeBonus.start();
  }

  stars(giftType=0) {
    this.present[this.currentPresent].stop();
    this.present[this.currentPresent].reset();
    this.present[this.currentPresent].manualEmitCount = 20;
    this.present[this.currentPresent].emitter = new BABYLON.Vector3(
      Main.sled.xpos(),
      Main.sled.ypos(),
      0
    );


    if(giftType===0)
    {
      this.present[this.currentPresent].blendMode =
      BABYLON.ParticleSystem.BLENDMODE_ADD;
      this.present[this.currentPresent].particleTexture =
      AssetLoader.getTexture("PresentSparks");
          this.present[this.currentPresent].endSpriteCellID = 2;
    }
    else 
    {
      this.present[this.currentPresent].particleTexture =
      AssetLoader.getTexture("PowerSprites" + giftType);
      this.present[this.currentPresent].endSpriteCellID = 3;
      this.present[this.currentPresent].blendMode =
      BABYLON.ParticleSystem.BLENDMODE_STANDARD;
    }
    var deadColor = new BABYLON.Color4(1, 1, 1, 0);
    this.present[this.currentPresent].colorDead = deadColor;

    this.present[this.currentPresent].start();
    this.currentPresent++;
    if (this.currentPresent > 4) this.currentPresent = 0;
  }

  addRainbow() {
    this.useRainbow = true;
    this.dustParticles.stop()
    this.rainbowParticles.start()
  }

  removeRainbow() {
    this.dustParticles.start();
    this.rainbowParticles.stop();
    this.useRainbow = false;
  }

  pause() {
    // if(this.isPaused === false) {
    //   this.particleSystem.animate = this.pauseAnimater
    //   this.isPaused = true
    // }
  }

  resume() {
    // if(this.isPaused) {
    //   this.particleSystem.animate = this.animater
    //   this.isPaused = false
    // }
  }
}
export default VFX;
